let ajaxCart = document.querySelector(".ajax-cart-wrap");
let ajaxCartOverlay = document.querySelector(".ajax-cart-overlay");
///////////////////////////Adding product to cart
function addToCart(data, display, loader) {
  fetch(window.Shopify.routes.root + "cart/add.js", {
    method: "POST",
    headers: {
      "Content-Type": "application/x-www-form-urlencoded",
    },
    body: data,
  })
    .then((response) => {
      if (response.ok) {
        renderProducts(loader, display);
        return response;
      } else {
        return response
          .json()
          .then((text) => cartError(text.description, loader));
      }
    })
    .catch((error) => {
      console.error("Error:", error);
    });
}
////////////// cart error handling
function cartError(error, loader) {
  let errorBox = document.querySelector(".cart-error-notification");
  let errorText = error;
  errorBox.querySelector(".error-notification").textContent = errorText;
  errorBox.classList.add("active");
  loader ? loader.classList.remove("active") : "";
  setTimeout(() => {
    errorBox.classList.remove("active");
  }, 2000);
}
////////////////Quantity selector
document.addEventListener("click", function (e) {
  if (
    e.target.classList.contains("btn-minus") ||
    e.target.closest(".btn-minus")
  ) {
    e.preventDefault();

    let el = e.target.classList.contains("btn-minus")
      ? e.target
      : e.target.closest(".btn-minus");
    updateQuantity(el, false);
  } else if (
    e.target.classList.contains("btn-plus") ||
    e.target.closest(".btn-plus")
  ) {
    e.preventDefault();
    let el = e.target.classList.contains("btn-plus")
      ? e.target
      : e.target.closest(".btn-plus");
    updateQuantity(el, true);
  }
});
function updateQuantity(element, increment) {
  let quantityInput = element.closest("form").querySelector(".quantity");
  let currentValue = Number(quantityInput.value);
  let currentLineItem = Number(element.closest(".cart-item").dataset.id);
  if (increment) {
    quantityInput.value = currentValue + 1;
  } else {
    quantityInput.value = currentValue - 1;
  }
  let url = element.getAttribute("href");
  url = url.replace(/quantity=(\d+)/, `quantity=${quantityInput.value}`);
  element.setAttribute("href", url);
  updateCartQuantity(url, element);
}
///////////////////////Updating cart item quantity
function updateCartQuantity(url, element) {
  let loader = element
    .closest(".cart-item-wrap")
    .querySelector(".loader-wrapper");
  loader.classList.add("active");
  fetch(url)
    .then((response) => {
      renderProducts(loader, false);
    })
    .catch((error) => console.error(error));
}
////////////////// render products
// function renderProducts(loader, display, render) {
//   fetch(`${window.location.pathname}?sections=ajax-cart`)
//     .then((response) => response.text())
//     .then((data) => {
//       loader ? loader.classList.remove("active") : "";
//       let htmlString = data
//         .replaceAll("\\n", "")
//         .replaceAll("\n", "")
//         .replaceAll("\\t", "")
//         .replaceAll("\\", "");
//       var parser = new DOMParser();
//       let html = parser.parseFromString(htmlString, "text/html");
//       console.log("data here",html)
//       // let cartTotal = html.querySelector(".cart-total").textContent;
//       let cartItems = html.querySelectorAll(".cart-item");
//       let currentItems = document.querySelectorAll(".cart-item");
//       let quantity = html.querySelector('input[data-id="cart-count"]').value;
//       let emptyText = html.querySelector(".empty-cart");
//       // let checkout = html.querySelector(".gokwik-checkout");
//       if (cartItems.length != currentItems.length || display) {
//         document.querySelector(".ajax-cart-body").innerHTML = "";
//         if(emptyText){
//           document.querySelector(".ajax-cart-body").appendChild(emptyText)
//           quantity == 0 ? checkout.style.display="none" ? checkout.style.display="block";
//         }
//         // emptyText
//         //   ? document.querySelector(".ajax-cart-body").appendChild(emptyText)
//         //   : "";
//         cartItems.forEach((el, ind) => {
//           document.querySelector(".ajax-cart-body").appendChild(el);
//         });
//       }
//       display ? displayAjaxCartToggle() : "";
//       updateCartCount(quantity);
//       // document.querySelector(".cart-total").textContent = cartTotal;
//     });
// }

function updateCheckoutVisibility(quantity) {
  let checkoutButton = document.querySelector(".gokwik-checkout");
  if (checkoutButton) {
    checkoutButton.style.display = quantity === 0 ? "none" : "block";
  }
}

function renderProducts(loader, display, render) {
  fetch(`${window.location.pathname}?sections=ajax-cart`)
    .then(response => response.text())
    .then(data => {
      if (loader) loader.classList.remove("active");

      // Clean and parse HTML
      let htmlString = data.replace(/\\n|\\t|\\/g, "").replace(/\n/g, "");
      let parser = new DOMParser();
      let html = parser.parseFromString(htmlString, "text/html");

      console.log("Parsed HTML:", html);

      // Extract necessary elements
      let cartItems = html.querySelectorAll(".cart-item");
      let currentItems = document.querySelectorAll(".cart-item");
      let quantity = parseInt(html.querySelector('input[data-id="cart-count"]')?.value || 0);
      let emptyText = html.querySelector(".empty-cart");
      let totalPrice = parseInt(html.querySelector('checkout-offer-bar[data-cart-price]')?.dataset.cartPrice || 0);
      let totalPriceNormal = html.querySelector('checkout-offer-bar[data-cart-price-normal]')?.dataset.cartPriceNormal || '';

      // If cart items change or display flag is true, update the cart
      if (cartItems.length !== currentItems.length || display) {
        let cartBody = document.querySelector(".ajax-cart-body");
        cartBody.innerHTML = ""; // Clear cart

        if (emptyText) cartBody.appendChild(emptyText);

        cartItems.forEach(item => cartBody.appendChild(item));
      }

      // Update checkout button visibility
      updateCheckoutVisibility(quantity);

      if (display) displayAjaxCartToggle();

      updateCartCount(quantity);

      throwUpdateCartEvent(quantity, totalPrice);
      document.querySelector('.cart-total').textContent = `${(totalPriceNormal)}`;
    })
    .catch(error => console.error("Error fetching cart data:", error));
}

// Ensure checkout button updates on page load
document.addEventListener("DOMContentLoaded", function () {
  let quantity = parseInt(document.querySelector('input[data-id="cart-count"]')?.value || 0);
  updateCheckoutVisibility(quantity);
});


//////////////////////////////Removing item from cart
document.addEventListener("click", function (e) {
  if (
    e.target.classList.contains("clear-prod") ||
    e.target.closest(".clear-prod")
  ) {
    e.preventDefault();
    let el = e.target.classList.contains("clear-prod")
      ? e.target
      : e.target.closest(".clear-prod");
    let minusBtn = el.closest(".cart-item").querySelector(".btn-minus");
    let url = minusBtn.getAttribute("href");
    url = url.replace(/quantity=(\d+)/, `quantity=0`);
    updateCartQuantity(url, minusBtn);
  }
});

function throwUpdateCartEvent(newCount, newPrice) {
  // This event is for checkout-offer-bar.js - checkout offer bar functionality
  const event = new CustomEvent("cartOfferUpdate", {
    detail: { newCount: newCount, newPrice: newPrice },
  });

  document.dispatchEvent(event);
}

//////Updating cart count
function updateCartCount(count) {
  console.log("update cart ");
  let countHolders = document.querySelectorAll(".cart-count");
  countHolders.forEach((el, ind) => {
    el.textContent = count;
  });
}
///////////////////Variant selector
document.addEventListener("click", function (e) {
  if (
    e.target.classList.contains("toggle-variant-wrap") ||
    e.target.closest(".toggle-variant-wrap")
  ) {
    e.preventDefault();
    let el = e.target.classList.contains("toggle-variant-wrap")
      ? e.target
      : e.target.closest(".toggle-variant-wrap");
    let parent = el.closest(".cart-item");
    let variantSelector = parent.querySelector(".variant-selectors-block");
    variantSelector.classList.toggle("active");
  }
});
///////////////////////cart display
document.addEventListener("click", function (e) {
  if (
    e.target.classList.contains("cart-toggle ") ||
    e.target.closest(".cart-toggle ")
  ) {
    e.preventDefault();
    displayAjaxCartToggle();
  } else if (
    e.target.classList != "ajax-cart-wrap" &&
    !e.target.closest(".ajax-cart-wrap")
  ) {
    ajaxCart.classList.remove("active");
  }
});
function displayAjaxCartToggle() {
  ajaxCart.classList.toggle("active");
  ajaxCartOverlay.classList.toggle("active");
}
////////////////ajax cart button
let formData = {
  items: [
    {
      id: 36110175633573,
      quantity: 2,
    },
  ],
};
document.addEventListener("click", function (e) {
  if (
    e.target.classList.contains("ajax-cart") ||
    e.target.closest(".ajax-cart")
  ) {
    e.preventDefault();
    console.log("button clicked");
    let el = e.target.classList.contains("ajax-cart")
      ? e.target
      : e.target.closest(".ajax-cart");
    let form = e.target.closest("form");
    let productId = form.querySelector('input[name="id"]').value;
    let quantity = form.querySelector(".quantity")
      ? form.querySelector(".quantity").value
      : 1;
    let formData = new URLSearchParams(new FormData(form)).toString();
    console.log(formData);
    let displayCart = document
      .querySelector(".ajax-cart-wrap")
      .classList.contains("active")
      ? false
      : true;
    let loader = el.closest("form").querySelector(".loader-wrapper");
    loader ? loader.classList.add("active") : "";
    loader
      ? addToCart(formData, displayCart, loader)
      : addToCart(formData, displayCart, false);
  }
});
